import React, { useState, useEffect } from "react";
import { Input, Button, Select, message, Form, Steps, Upload } from "antd";
import PhoneInput from "react-phone-input-2";
import { getCompanyData } from "../../../API/Admin/company";

const EmergencyContact = ({ onNext, onCancel, initialValues }) => {
  const [form] = Form.useForm();

  const [recoveryCompanies, setRecoveryCompanies] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const fetchRecoveryCompanies = async () => {
      try {
        const res = await getCompanyData();

        if (Math.floor(res.status / 100) === 2) {
          const companies = res.data.companies
            .filter((c) => c.status === "Active" || c.status === null)
            .map((c) => ({
              label: c.company_name,
              value: c.id,
            }));

          setRecoveryCompanies(companies);
        }
      } catch (error) {
        message.error("Failed to load recovery companies");
      }
    };

    fetchRecoveryCompanies();
  }, []);

  const handleBack = () => {
    onCancel?.();
  };

  const handleNext = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();

      onNext(values);
    } catch (error) {
      messageApi.error("Please fill in all required fields");
    }
  };
  return (
    <div className="customer-form">
      <Form form={form} layout="vertical" initialValues={initialValues}>
        <div className="add-container">
          <div className="heading">Emergency Contact</div>
          <div className="details">
            <div className="input-group">
              <div className="title">Contact Person's Name</div>
              <Form.Item
                name="personName"
                rules={[
                  {
                    required: true,
                    message: "Please enter the contact person's name",
                  },
                ]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>
            </div>
            <div className="input-group">
              <div className="title">Contact Person’s Phone Number</div>
              <Form.Item
                name="personPhone"
                rules={[
                  {
                    required: true,
                    message: "Please enter the contact person's phone number",
                  },
                ]}
              >
                <PhoneInput
                  country={"jm"}
                  placeholder="Enter Phone Number"
                  inputClass="phone-input"
                  specialLabel={false}
                  onChange={(value) => {
                    form.setFieldsValue({
                      personPhone: value.startsWith("+") ? value : `+${value}`,
                    });
                  }}
                />
              </Form.Item>
            </div>
          </div>
        </div>

        <div className="add-container">
          <div className="heading">Select Recovery Company</div>
          <div className="details">
            <div className="input-group">
              <div className="title">Recovery Company</div>

              <Form.Item
                name="recoveryCompany"
                rules={[
                  {
                    required: true,
                    message: "Please select a recovery company",
                  },
                ]}
              >
                <Select
                  placeholder="Select Recovery Company"
                  options={recoveryCompanies}
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>

      <div className="form-actions">
        <Button onClick={handleBack}>Back</Button>
        <Button
          className="save-btn"
          type="primary"
          onClick={() => {
            handleNext();
          }}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default EmergencyContact;
